import groq from "groq";
import { officeRouteSlugFromOffice } from "./utils/office-route-slug";

/**
 * Shared URL projection for office home page URLs (Site Builder: office from context).
 * Format: /home-care/{country}/{state}/{slug}/{officeRouteSlug}/
 * Decimal satellite office IDs use hyphenated path segments (116.2 → 116-2).
 */
const homePageUrlProjectionSB = `
  "pageUrl": 
    "/home-care/" +
      select(
        office.address.country == "US" => "usa",
        office.address.country == "CA" => "can",
        true => lower(office.address.country)
      ) + "/" +
      lower(office.address.stateProvince) + "/" +
      office.urlSlug + "/" +
      ${officeRouteSlugFromOffice} + "/"
`;

/**
 * Offices in a given state (Site Builder home pages).
 * $country: "US" | "CA", $state: state/province code (e.g. "TX", "ON").
 */
const OfficesByStateQuery = groq`
*[
  _type == "routeNode" &&
  isEnabled == true &&
  defined(page._ref) &&
  count(context[_type == "officeRef"]) > 0
] {
  "office": context[_type == "officeRef"][0]->,
  "nodeSlug": slug.current
}[
  office != null &&
  office.enabled == true &&
  defined(office.urlSlug) &&
  office.address.country == $country &&
  lower(office.address.stateProvince) == lower($state) &&
  nodeSlug == ${officeRouteSlugFromOffice}
] | order(office.officeID asc) {
  "officeID": office.officeID,
  "officeName": office.locationName,
  "slug": office.urlSlug,
  "city": office.address.city,
  "state": office.address.stateProvince,
  "country": office.address.country,
  "phone": office.phone,
  "addressLine1": office.address.addressLine1,
  "addressLine2": office.address.addressLine2,
  "postalCode": office.address.postalCode,
  ${homePageUrlProjectionSB}
}`;

type OfficeByStateItem = {
  officeID: number;
  officeName: string;
  slug: string;
  city: string;
  state: string;
  country: string;
  phone: string;
  addressLine1: string;
  addressLine2: string | null;
  postalCode: string;
  pageUrl: string;
};

export type { OfficeByStateItem };

export { OfficesByStateQuery };
